export class UnifyConfig {
    constructor(o) {
        o = o === undefined ? {} : o;
        var brandedColors = typeof o.brandedColors !== 'undefined' ? o.brandedColors : '';
        var colorScheme = typeof o.colorScheme !== 'undefined' ? o.colorScheme : '';
        var endpoints = typeof o.endpoints !== 'undefined' ? o.endpoints : '';
        var globalMenu = typeof o.globalMenu !== 'undefined' ? o.globalMenu : '';
        var isATestEnvironment = typeof o.isATestEnvironment !== 'undefined' ? o.isATestEnvironment : '';
        var localizations = typeof o.localizations !== 'undefined' ? o.localizations : '';
        var systemInformation = typeof o.systemInformation !== 'undefined' ? o.systemInformation : '';
        var translations = typeof o.translations !== 'undefined' ? o.translations : '';
        var userInformation = typeof o.userInformation !== 'undefined' ? o.userInformation : '';

        if (this.isEmpty('brandedColors', brandedColors, o) ||
            this.isEmpty('colorScheme', colorScheme, o) ||
            this.isEmpty('endpoints', endpoints, o) ||
            this.isEmpty('globalMenu', globalMenu, o) ||
            this.isEmpty('isATestEnvironment', isATestEnvironment, o) ||
            this.isEmpty('localizations', localizations, o) ||
            this.isEmpty('systemInformation', systemInformation, o) ||
            this.isEmpty('translations', translations, o) ||
            this.isEmpty('userInformation', userInformation, o)) {
            return;
        }

        this.brandedColors = brandedColors;
        this.colorScheme = colorScheme;
        this.endpoints = endpoints;
        this.globalMenu = globalMenu;
        this.isATestEnvironment = isATestEnvironment;
        this.localizations = localizations;
        this.systemInformation = systemInformation;
        this.translations = translations;
        this.userInformation = userInformation;
    }

    isEmpty(propertyName, property, o) {
        if (property === ''){
            console.log('Error UnifyConfig, need to be initialized with ' + propertyName + ', o:', o);
            return true;
        }
        return false;
    }
}